import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/* Initialise Video Elements on page with videojs */

document.addEventListener("DOMContentLoaded", function () {

  const videoInstances   = document.querySelectorAll('.video-js');
  if (videoInstances) {

    const mobileBreakpoint = 576;
    let currentIsMobile = window.innerWidth < mobileBreakpoint;
    const videoPlayers = [];

    videoInstances.forEach(item => {
      const videoElem = item;
      const parentWrapper = videoElem.closest('.fs-media-wrapper');
      const overlay = parentWrapper.querySelector('.js-loader-overlay');
      const loaderAnimContainer = parentWrapper.querySelector('.fs-media-wrapper__loader-anim');

      const src = currentIsMobile
          ? videoElem.dataset.srcMobile
          : videoElem.dataset.srcDesktop;

      if (src) {
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        videoElem.appendChild(source);
      }

      videoElem.muted = true;
      videoElem.setAttribute('muted', '');
      videoElem.setAttribute('playsinline', '');
      videoElem.setAttribute('webkit-playsinline', '');
      videoElem.setAttribute('autoplay', '');
      let player = videojs(videoElem, {
        autoplay: false,
        preload: 'none',
        controls: false,
        loop: true,
        muted: true
      });

      const anim = lottie.loadAnimation({
        container: loaderAnimContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: window.params.assets_path + '/assets/img/uploads/striker_Preloader.json',
        preserveAspectRatio: 'xMidYMid meet' // This will scale down to fit, without cropping
      });
      anim.setSpeed(1.5); // Make a bit faster
      videoPlayers.push({
        element: videoElem, 
        player: player, 
        loader: anim,
        parentWrapper: parentWrapper,
        overlay: overlay,
        loaderAnimContainer: loaderAnimContainer
      });
    });

    // Create ScrollTriggers only after the window has fully loaded (Styles & Layout stable)
    window.addEventListener("load", () => {
      
      // Force a refresh to ensure GSAP sees the correct document height
      ScrollTrigger.refresh();

      videoPlayers.forEach((vp) => {
        const { element, player, loader, parentWrapper, overlay, loaderAnimContainer } = vp;

        const st = ScrollTrigger.create({
          trigger: parentWrapper,
          start: "top 80%",
          end: "bottom 20%",
          onEnter: () => {
            if (ScrollTrigger.isInViewport(parentWrapper)) {
               initVideoPlayback(vp);
            }
          },
          onEnterBack: () => {
            if (ScrollTrigger.isInViewport(parentWrapper)) {
               initVideoPlayback(vp);
            }
          }
        });
        
        // Save trigger back to object if needed for resize logic
        vp.trigger = st;
      });
    });

    // Helper function updated to take the object
    function initVideoPlayback({ element, player, parentWrapper, trigger, loader, overlay, loaderAnimContainer }) {
        if (!parentWrapper.hasAttribute('data-played')) {
          player.load();
          player.ready(() => {
            parentWrapper.classList.add('playing');
            parentWrapper.setAttribute('data-played', 'true');
            if(trigger) trigger.kill(); // trigger might be null if called oddly, but here it's safe
            loader.stop();
            loaderAnimContainer.style.display = 'none';
            gsap.to(overlay, {opacity: 0, duration: 2, ease: 'power1.out', onComplete: () => { 
              loader.stop(); 
            }});
            player.muted(true);
            player.play().catch(err => console.warn("Autoplay blocked:", err.message));
          });
        }
    }
    
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        onResize();
      }, 250);
    });

    function onResize() {
      const newIsMobile = window.innerWidth < mobileBreakpoint;

      // Only proceed if the mobile state has actually changed
      if (newIsMobile !== currentIsMobile) {

        currentIsMobile = newIsMobile; // Update the global state

        videoPlayers.forEach(({element, player}) => {
          const newSrc = currentIsMobile
              ? element.dataset.srcMobile
              : element.dataset.srcDesktop;

          if (newSrc && newSrc !== player.currentSrc()) {
            player.src({src: newSrc, type: 'video/mp4'});
            if (element.closest('.fs-media-wrapper').hasAttribute('data-played')) {
              player.load();
              player.play().catch(err => {
                console.warn('Autoplay blocked for video after reload:', err.message);
              });
            }
          }
        });
      }
    }
  }
});